import { render, staticRenderFns } from "./ShortArticleCheckToDelete.vue?vue&type=template&id=229c18e4&"
import script from "./ShortArticleCheckToDelete.vue?vue&type=script&lang=js&"
export * from "./ShortArticleCheckToDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports